import { BLOG_SERVER_URL } from '@/constants/urls';

const imageSizes = [
  'h412px/',
  'h630px/',
  'h1280px/'
];

const buildLinkedData = (
  article
) => {
  const imagesList = imageSizes.map((size) => BLOG_SERVER_URL + size + article?.imageName);

  if (article) {
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: article.title,
      image: imagesList,
      datePublished: article.publishedAt,
      dateModified: article.createdAt,
      author: {
        '@type': 'Person',
        name: article.author.fullName,
        url: article.author?.url || ''
      }
    };
  } else {
    return '';
  }
};

export default buildLinkedData;
